// Derive the WS endpoint from the same API base the rest of the app uses
// (see fetchWrapper.js) instead of hardcoding a domain that can drift out of sync.
const API_BASE = process.env.REACT_APP_API_BASE || "http://localhost:9500/api/v1";

const deriveWsUrl = (apiBase) => {
  try {
    const url = new URL(apiBase);
    const wsProtocol = url.protocol === "https:" ? "wss:" : "ws:";
    return `${wsProtocol}//${url.host}/ws`;
  } catch {
    return "ws://localhost:9500/ws";
  }
};

export const WS_URL = deriveWsUrl(API_BASE);